export const firebaseConfig = {
    apiKey: "AIzaSyARhcAPw5FK6e1ZnWWsMl4W-VbNpVP4Eyg",
    authDomain: "ganesha-ef774.firebaseapp.com",
    projectId: "ganesha-ef774",
    storageBucket: "ganesha-ef774.appspot.com",
    messagingSenderId: "320227347610",
    appId: "1:320227347610:web:1de3ffef4344c118b5a323",
    measurementId: "G-HGPV14XG7P"
};